const BLOCKED_EVENT_PATHS = [
  "/evento/estudio-violencia-y-vulneracion-de-derechos-humanos-en-contextos-de-mineria-no-legal-en-el-peru-24092026174006",
];

const HOME_PATH = "/home/";

const normalizePath = (pathname) => {
  if (!pathname) return "/";
  const path = String(pathname).split("?")[0].split("#")[0];
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path;
};

const isBlockedEventPath = (pathname) => {
  const current = normalizePath(pathname);
  return BLOCKED_EVENT_PATHS.some(
    (blocked) => normalizePath(blocked) === current
  );
};

const redirectBlockedEvent = () => {
  if (typeof window === "undefined") return false;
  if (!isBlockedEventPath(window.location.pathname)) return false;
  window.location.replace(HOME_PATH);
  return true;
};

const getBlockedEventRedirectScript = () => {
  const blocked = BLOCKED_EVENT_PATHS.map(normalizePath);
  return `(function(){var blocked=${JSON.stringify(
    blocked
  )};var path=location.pathname||"/";if(path.length>1&&path.charAt(path.length-1)==="/"){path=path.slice(0,-1);}for(var i=0;i<blocked.length;i++){if(path===blocked[i]){location.replace(${JSON.stringify(
    HOME_PATH
  )});return;}}})();`;
};

const getBlockedEventRedirectHtml = () => `<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="utf-8" />
    <title>Agenda PUCP</title>
    <meta http-equiv="refresh" content="0; url=${HOME_PATH}" />
    <script>${getBlockedEventRedirectScript()}</script>
  </head>
  <body></body>
</html>
`;

module.exports = {
  BLOCKED_EVENT_PATHS,
  HOME_PATH,
  isBlockedEventPath,
  redirectBlockedEvent,
  getBlockedEventRedirectScript,
  getBlockedEventRedirectHtml,
};
